import { cn, PaletteUtils } from '@shared/utils';
import type { UserResponse } from '@shared/api';
import { Text } from '@shared/widgets';

interface ManagerListProps {
  className?: string;
  data: UserResponse[];
}

export const ManagerList = (props: ManagerListProps) => {
  return (
    <div className={cn('flex gap-4 overflow-auto', props.className)}>
      {props.data.map((item, idx) => (
        <div key={idx} className='flex items-center gap-3 rounded-sm bg-white p-3 dark:bg-soft-black'>
          <div
            className={cn(
              'flex h-9 w-9 flex-none items-center justify-center rounded-3xl text-ice',
              PaletteUtils.isInsigniaPalette && 'bg-soft-black dark:bg-primary',
              PaletteUtils.isVcfcPalette && 'bg-primary',
            )}
          >
            <Text color='white'>{item?.displayName[0].toUpperCase()}</Text>
          </div>
          <div className='flex-1 flex-col justify-center gap-0.5'>
            <Text>{item.displayName}</Text>
          </div>
        </div>
      ))}
    </div>
  );
};
